var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTalkingPostLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 246,
  height: 120,
  viewBox: "0 0 246 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_15331)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_di_1_15331)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.3923 13.0568L15.5229 13.2973L13.6494 23.7843H9.61426L10.4309 9.88184H41.4151L41.9916 23.7843H38.1966L36.3231 13.2973L29.5498 13.0568V42.2566L36.275 42.7377V45.624H16.2435V42.7377L22.3923 42.2566V13.0568Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.1584 9.68945H63.5082L74.6049 42.2566L77.391 42.7377V45.624H63.22V42.7377L66.8227 42.2566L64.9493 36.003H52.5076L50.6341 42.3048L54.5252 42.7377V45.624H42.2755L42.2275 42.7377L45.1098 42.2566L56.1584 9.68945ZM59.473 17.8192L58.6083 14.067L57.6956 17.8673L53.4203 32.6356H63.9885L59.473 17.8192Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.4902 13.4898L78.7914 12.8644V9.88184H94.1634V12.8644L89.5518 13.4898V42.2085L99.8317 41.7756L102.858 32.7799L106.749 33.309L105.26 45.624H78.6953V42.7377L82.4902 42.2566V13.4898Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.788 45.624C134.308 45.624 133.683 45.0147 132.914 43.796C132.146 42.5453 131.073 40.5729 129.696 37.8791C128.511 35.5701 127.518 33.71 126.718 32.2989C125.917 30.8878 125.148 29.7173 124.412 28.7872L120.137 33.6939V42.2566L124.268 42.7858V45.624H109.328V42.7377L113.123 42.2566V13.4898L109.376 12.8644V9.88184H123.836V12.8644L120.137 13.4898V29.1721L132.771 13.4898L128.831 12.8644V9.88184H141.802V12.8644L137.814 13.4898L128.495 23.9766C129.616 25.0029 130.801 26.4622 132.05 28.3543C133.299 30.2143 134.82 32.6516 136.613 35.6662C137.927 37.8791 138.919 39.4986 139.592 40.5248C140.265 41.519 140.777 42.0963 141.129 42.2566L143.386 42.7858V45.624H134.788Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.541 13.4898L145.457 12.8644V9.88184H160.829V12.8644L156.602 13.4898V42.2566L160.829 42.7858V45.624H145.457V42.7377L149.541 42.2566V13.4898Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.713 13.4898L164.918 12.8644V9.88184H175.823L190.138 31.5292L192.828 37.0132V13.4898L188.697 12.8644V9.88184H200.61V12.8644L196.911 13.4898V45.624H191.099L176.159 22.8703L172.797 16.5204V42.2566L177.649 42.7377V45.624H164.918V42.7377L168.713 42.2566V13.4898Z",
  fill: "#0CB6FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.101 46.153C216.578 46.153 213.536 45.3833 210.974 43.8439C208.444 42.2725 206.523 40.1238 205.209 37.3979C203.896 34.6719 203.24 31.5932 203.24 28.1616C203.24 24.217 203.992 20.8336 205.498 18.0114C207.035 15.1893 209.197 13.0567 211.982 11.6135C214.769 10.1703 218.019 9.44873 221.734 9.44873C225.225 9.44873 229.148 9.94583 233.504 10.94L232.975 19.8876H228.124L226.826 13.7301C226.506 13.4094 225.898 13.1207 225.001 12.8642C224.104 12.5755 222.935 12.4312 221.494 12.4312C218.356 12.4312 215.889 13.714 214.096 16.2797C212.303 18.8132 211.406 22.4853 211.406 27.2958C211.406 32.0101 212.175 35.8264 213.712 38.7448C215.25 41.6311 217.587 43.0742 220.725 43.0742C222.007 43.0742 223.207 42.9139 224.328 42.5932C225.449 42.2725 226.298 41.8556 226.875 41.3425V30.9999L221.783 30.5188V27.2958H236.386V30.5188L233.839 30.9518V43.6997C233.167 43.7317 231.95 44.0043 230.189 44.5175C228.14 45.0626 226.378 45.4635 224.904 45.7201C223.464 46.0087 221.862 46.153 220.101 46.153Z",
  fill: "#0CB6FC"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_di_1_15331)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.5492 59.9312L27.0005 58.9681V54.3746H38.172C39.2076 54.3746 40.8106 54.3252 42.9808 54.2265C45.8415 54.0289 48.4309 53.9302 50.749 53.9302C55.8785 53.9302 59.9229 54.5722 62.8822 55.8564C65.8908 57.0912 68.0117 58.894 69.2448 61.2647C70.5271 63.5862 71.1683 66.5496 71.1683 70.1552C71.1683 76.3786 69.2201 81.2189 65.3236 84.6763C61.4765 88.1338 56.1251 89.8624 49.2694 89.8624C46.5567 89.8624 44.6084 89.7884 43.4247 89.6402V104.236L53.3384 104.977V109.421H26.7046V104.977L32.5492 104.236V59.9312ZM43.3508 84.8986C44.4851 85.1456 46.4087 85.269 49.1214 85.269C52.426 85.269 55.0647 84.133 57.0376 81.861C59.0598 79.5396 60.0708 75.7118 60.0708 70.3774C60.0708 66.2286 59.1585 63.2157 57.3335 61.3389C55.5579 59.4126 52.8206 58.4494 49.1214 58.4494C47.7404 58.4494 46.31 58.5483 44.8304 58.7458C44.1398 58.8446 43.6467 58.894 43.3508 58.894V84.8986Z",
  fill: "#F121F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.4082 110.237C90.3687 110.237 84.3515 107.718 80.3564 102.68C76.3613 97.6416 74.3638 90.7763 74.3638 82.0835C74.3638 76.4034 75.3995 71.4149 77.4711 67.1179C79.5919 62.8207 82.5513 59.5116 86.349 57.1902C90.1468 54.8687 94.5118 53.708 99.4438 53.708C107.582 53.708 113.674 56.1282 117.718 60.9686C121.812 65.7596 123.859 72.4768 123.859 81.1203C123.859 86.8497 122.773 91.937 120.603 96.3821C118.482 100.778 115.498 104.186 111.652 106.607C107.804 109.026 103.39 110.237 98.4082 110.237ZM99.148 58.2274C95.1039 58.2274 91.9471 60.2277 89.6782 64.2284C87.4095 68.2291 86.275 74.1561 86.275 82.0093C86.275 89.7638 87.3601 95.6659 89.5303 99.7166C91.7498 103.717 94.9064 105.718 98.9997 105.718C102.996 105.718 106.127 103.618 108.396 99.4199C110.665 95.1717 111.799 89.0723 111.799 81.1203C111.799 73.4152 110.714 67.6858 108.544 63.9321C106.374 60.129 103.242 58.2274 99.148 58.2274Z",
  fill: "#F121F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.429 110.237C144.766 110.237 142.373 110.014 140.252 109.57C138.132 109.126 135.764 108.532 133.151 107.792C131.424 107.297 130.265 107.026 129.673 106.977L130.339 93.2706H136.332L137.959 102.828C138.601 103.52 139.734 104.137 141.362 104.68C143.04 105.223 144.938 105.495 147.059 105.495C150.363 105.495 152.83 104.779 154.458 103.347C156.134 101.864 156.973 99.8148 156.973 97.1975C156.973 95.4684 156.48 93.9868 155.493 92.7519C154.507 91.4678 153.15 90.3318 151.424 89.3439C149.697 88.3067 147.33 87.1214 144.322 85.7878C140.228 83.9109 136.825 81.6883 134.112 79.1199C131.449 76.5022 130.116 72.9707 130.116 68.5255C130.116 65.7596 130.832 63.2653 132.262 61.0427C133.693 58.7707 135.813 56.9926 138.625 55.7084C141.485 54.3748 144.962 53.708 149.057 53.708C151.474 53.708 153.594 53.8809 155.419 54.2267C157.293 54.5724 159.315 55.0416 161.486 55.6343C162.768 55.9801 163.73 56.2023 164.371 56.3011L163.927 69.2663H158.008L156.455 60.1536C156.011 59.7091 155.123 59.2892 153.791 58.8942C152.46 58.4496 150.98 58.2274 149.352 58.2274C146.393 58.2274 144.149 58.9188 142.62 60.3018C141.14 61.6354 140.401 63.4381 140.401 65.7102C140.401 67.5377 140.943 69.1182 142.028 70.4518C143.162 71.7853 144.519 72.9213 146.097 73.8598C147.675 74.7488 150.166 76.033 153.569 77.7123C156.331 79.0459 158.699 80.3547 160.672 81.6389C162.645 82.9231 164.347 84.6024 165.776 86.6768C167.207 88.7019 167.922 91.0974 167.922 93.8633C167.922 96.5796 167.231 99.1733 165.851 101.642C164.519 104.112 162.299 106.162 159.192 107.792C156.134 109.421 152.213 110.237 147.429 110.237Z",
  fill: "#F121F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.383 59.2643L179.803 59.6348L176.918 75.7857H170.704L171.961 54.3745H219.68L220.568 75.7857H214.723L211.838 59.6348L201.407 59.2643V104.236L211.763 104.976V109.421H180.913V104.976L190.383 104.236V59.2643Z",
  fill: "#F121F5"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_di_1_15331",
  x: 0.16544,
  y: -0.000087738,
  width: 245.669,
  height: 55.6017,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.72441
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.054902 0 0 0 0 0.862745 0 0 0 0 0.960784 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_15331"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_15331",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.41732
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0155556 0 0 0 0 0.336895 0 0 0 0 0.466667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1_15331"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_di_1_15331",
  x: 17.2558,
  y: 44.2592,
  width: 212.761,
  height: 75.4264,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.72441
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.913725 0 0 0 0 0.270588 0 0 0 0 0.968627 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_15331"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_15331",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.3622
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_1_15331"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_15331"
}, /*#__PURE__*/React.createElement("rect", {
  width: 245.669,
  height: 120,
  fill: "white",
  transform: "translate(0.165527)"
})))));
export default SvgTalkingPostLogo;